import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import Loading from '../Loading';



export const simpleRenderer = (row) => {
  return (
    <tr>
      {
        Object.keys(row).map((field, idx) => {
          return (<td key={row.id || idx}>{row[field]}</td>);
        })
      }
    </tr>
  );
};

export default function List({ headers, rows, children, emptyMessage, loading }) {
  if (loading) {
    return (
      <Loading />
    );
  }
  return (
    <div className="list__table">
      <table>
        <thead>
          <tr>
            {headers.map((h) => {
              return (
                <th key={h.label}>{h.label}</th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {rows.length
          ? rows.map(children)
          : (
            <tr>
              <td colSpan={headers.length}>{emptyMessage}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

List.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
  })).isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  children: PropTypes.func,
  loading: PropTypes.bool,
  emptyMessage: PropTypes.string,
};

List.defaultProps = {
  emptyMessage: 'Empty',
  loading: false,
  children: simpleRenderer,
};
